export default __webpack_public_path__ + "static/media/hm-mg-img.edf5b736.webp";